import React, { createContext, useMemo, useState } from "react";
import { FailurePop, SuccessPop } from "../Popup";
import { useDispatch, useSelector } from "react-redux";
import { CurrentBranch, CurrentCar, CurrentLoc } from "../reducers/config";

export const AppContext = createContext();

export const AppContextProvider = ({ children }) => {
  const dispatch = useDispatch();

  const [cartCount, setcartCount] = useState(0);
  const [carValue, setCarValue] = useState({});
  const [CarList, setCarList] = useState([]);
  const [userDetail, setUserDetail] = useState({});
  const [modalSuccess, setModalSuccess] = useState(false);
  const [modalFail, setModalFail] = useState(false);
  const [content, setContent] = useState("");
  const [location, setLocation] = useState(null);
  const [branchValue, setBranchValue] = useState(null);
  const [branchDrop, setBranchDrop] = useState([]);
  const [newUser, setNewUser] = useState("new");
  const [cartList, setCartList] = useState([]);
  const [cartLoad, setCartLoad] = useState(false);
  const [total, setTotal] = useState("");
  const [offerTotal, setOfferTotal] = useState("");
  const [subTotal, setSubTotal] = useState("");
  const [tax, setTax] = useState("");
  const [openSignin, setOpenSignin] = useState(false);
  const [offerDate, setOfferDate] = useState(null);
  const [nearestPop, setNearestPop] = useState(false);

  const [loader, setLoader] = useState(true);
  const [currentAddress, setCurrentAddress] = useState(null);
  const cBranch = useSelector((data) => data.branch);
  const cCar = useSelector((data) => data.car);
  const getLoc = useSelector((data) => data.cLoc);
  const signIn = useSelector((data) => data.signinStatus);

  const [getUserDataflag, setgetUserDataflag] = useState(false);

  const AddtoCart = async (data) => {
    if (!signIn) {
      setOpenSignin(true);
      return true;
    }
    if (CarList?.length == 0) {
      setContent("Please Add Your Car");
      setModalFail(true);
      setTimeout(() => {
        setModalFail(false);
      }, 1500);
      return true;
    }
    setCartLoad(true);
    try {
      const payload = {
        customer_id: global.$userData.id,
        service_id: data?._id,
        group_id: data?.service_group_id || "",
        cat_id: data?.service_cat_id,
        subcat_id: data?.service_subcat_id,
        price_id: data?.price_id,
        price: data?.price,
        actualPrice: data?.actual_price,
        taxPercentage: data?.taxPercentage,
        brand_id: carValue?.brand_id?._id,
        model_id: carValue?.model_id?._id,
        type_id: carValue?.type_id?._id,
        size_id: carValue?.size_id?._id,
        year: carValue.year,
        reg_number: carValue.reg_number,
        type: data?.type === "amcService" ? "amcService" : "regular",
        taxAmount: data?.tax_amount,
      };

      const response = await global.$axios.post("cart/addToCart", payload);
      if (response.data.status == "success") {
        setContent("Added To Cart");
        await fetchCartList();
        setModalSuccess(true);

        setTimeout(() => {
          setModalSuccess(false);
        }, 1500);
        setCartLoad(false);
      } else {
        console.log("Add Cart Something Went Wrong");
        setCartLoad(false);
      }
    } catch (error) {
      console.log("Add To Cart Issue", error);
      setCartLoad(false);
    }
  };

  const RemoveCart = async (id) => {
    console.log("iddd", id);
    setCartLoad(true);
    try {
      const response = await global.$axios.post("cart/deleteCart", {
        cart_id: id,
      });
      if (response.data.status == "success") {
        setContent("Removed From Cart");
        fetchCartList();
        setModalSuccess(true);
        setCartLoad(false);

        setTimeout(() => {
          setModalSuccess(false);
        }, 1500);
      } else {
        setModalFail(true);
        setContent("Try Again");
        setTimeout(() => {
          setModalFail(false);
        }, 1500);
        console.log("Remove Cart Issue");
        setCartLoad(false);
      }
    } catch (error) {
      console.log("Remove Cart Issue", error);
      setCartLoad(false);
    }
  };

  const fetchCartList = async () => {
    try {
      const response = await global.$axios.get(
        `cart/listCart/${global.$userData.id}`
      );
      if (response.data.status == "success") {
        const respo = response.data.message;

        setCartList(respo);
        setcartCount(respo?.length);

        const total = respo.reduce((a, b) => a + Number(b?.total_amount), 0);
        const subTot = respo.reduce((a, b) => a + Number(b?.actual_price), 0);
        const taxes = respo.reduce((a, b) => a + Number(b?.taxAmount), 0);
        /* To get offer validity date */
        if (respo?.length > 0) {
          const findService = respo?.find(
            (service) => service.is_offer_service
          );
          if (findService) {
            setOfferDate(response.data?.couponData?.validity_to || null);
          } else {
            setOfferDate(null);
          }
        }

        const offer_total = respo?.reduce(
          (a, b) =>
            a +
            Number(b?.is_offer_service ? b?.discounted_price : b?.total_amount),
          0
        );
        setTotal(total);
        setSubTotal(subTot);
        setOfferTotal(offer_total);
        setTax(taxes);
        setLoader(false);
      } else {
        console.log("Cart List Issue", response.data.message);
        setCartList([]);
        setLoader(false);
      }
    } catch (error) {
      console.log("fetchCartList Issue", error);
      setLoader(false);
    }
  };

  const fetchCarList = async () => {
    try {
      const response = await global.$axios.get(
        `customer/carList/${global.$userData.id}`
      );
      if (response.data.status == "success") {
        const respo = response?.data?.list?.vehicle_details;

        setCarList(respo);
        const defaultCar = respo[0] || null;

        setCarValue(cCar?.reg_number ? cCar : defaultCar);
        const matchValue = respo.find((x) => x._id === cCar?._id);
        if (matchValue) {
          dispatch(CurrentCar(matchValue));
          setCarValue(matchValue);
        }

        if (!cCar?.reg_number) {
          dispatch(CurrentCar(defaultCar));
        }
      } else {
        setCarList([]);
      }
    } catch (error) {
      console.log("car List Issue", error);
    }
  };

  const getUserData = async () => {
    setgetUserDataflag(false);
    setLoader(true);
    try {
      const response = await global.$axios.get(
        `customer/get/${global?.$userData?.id}`
      );
      if (response.data.status == "success") {
        const apiResponse = response.data.getList;
        setUserDetail(apiResponse);

        const defaultAddress = apiResponse?.address_details?.[0] || null;
        setCurrentAddress(
          Object.values(getLoc).length > 0 ? getLoc : defaultAddress
        );
        if (Object.values(getLoc).length === 0) {
          dispatch(CurrentLoc(defaultAddress || {}));
        }
        setgetUserDataflag(true);
        setLoader(false);
      } else {
        console.log("user Info Issue(App context)");
        setLoader(false);
        setgetUserDataflag(true);
      }
    } catch (error) {
      console.log("user Detail Issue", error);
      setLoader(false);
      setgetUserDataflag(true);
    }
  };

  const branchList = async (longitude, latitude) => {
    try {
      const response = await global.$axios.post("location/findBranch", {
        Longitude: longitude,
        Latitude: latitude,
        id: global.$userData.id,
      });

      if (response.data.status == "success") {
        const apiRes = response?.data?.data;
        if (apiRes?.length > 0) {
          setNearestPop(false);

          setBranchDrop(apiRes);
          if (!cBranch) {
            dispatch(CurrentBranch(apiRes[0] ? apiRes[0] : {}));
          }
          setBranchValue(
            Object.values(cBranch).length > 0 ? cBranch : apiRes[0]
          );

          if (apiRes?.length > 0 && !cBranch?._id) {
            const matchedBranch = apiRes.find(
              (branch) => branch._id === cBranch?._id
            );
            if (!matchedBranch) {
              const defaultBranch = apiRes[0];
              dispatch(CurrentBranch(defaultBranch));
              setBranchValue(defaultBranch);
            }
          }
        } else {
          setNearestPop(true);
          setBranchDrop([]);
        }
      } else {
        setBranchDrop([]);
      }
    } catch (error) {
      console.log("Branch List Issue", error);
    }
  };

  const values = useMemo(
    () => ({
      cartCount,
      setcartCount,
      AddtoCart,
      RemoveCart,
      fetchCartList,
      cartLoad,
      loader,
      cartList,
      total,
      offerTotal,
      subTotal,
      tax,

      fetchCarList,
      CarList,
      setCarList,
      carValue,
      setCarValue,

      getUserData,
      getUserDataflag,
      userDetail,
      location,
      setLocation,
      setCurrentAddress,
      currentAddress,

      branchDrop,
      setBranchDrop,
      setBranchValue,
      branchValue,
      branchList,

      setNewUser,
      newUser,
      openSignin,
      setOpenSignin,
      signIn,
      offerDate,
      nearestPop,
      setNearestPop,
    }),
    [
      cartCount,
      setcartCount,
      AddtoCart,
      RemoveCart,
      fetchCartList,
      cartLoad,
      loader,
      cartList,
      total,
      offerTotal,
      subTotal,
      tax,

      fetchCarList,
      CarList,
      setCarList,
      carValue,
      setCarValue,

      getUserData,
      getUserDataflag,
      userDetail,
      location,
      setLocation,
      setCurrentAddress,
      currentAddress,

      branchDrop,
      setBranchDrop,
      setBranchValue,
      branchValue,
      branchList,

      setNewUser,
      newUser,
      openSignin,
      setOpenSignin,
      signIn,
      offerDate,
      nearestPop,
    ]
  );

  return (
    <>
      <AppContext.Provider value={values}>{children}</AppContext.Provider>

      {modalSuccess && (
        <SuccessPop
          modalSuccess={modalSuccess}
          setModalSuccess={setModalSuccess}
          content={content}
        />
      )}

      {modalFail && (
        <FailurePop
          modalFail={modalFail}
          setModalFail={setModalFail}
          content={content}
        />
      )}
    </>
  );
};
